module.exports = __webpack_public_path__ + "static/media/F8.1881aeb5.webp";